/**
 * 用户信息实体
 * zxw
 * 创建时间：2024-01-20
 * 修改时间：2026-08-12
 */

import { useState, useEffect } from 'react';
import {
    Modal, Flex, Input, Row, Col, message,
    Radio, DatePicker, Select, Typography
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, UjoinParams, currentDate } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

const { TextArea } = Input;
const { Text } = Typography;

const Entity = (props) => {
    const { open, setOpen, record, refresh } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);

    const [sid, setSid] = useState('');

    const [sex, setSex] = useState(CNF.sexs[0].value);
    const [idcard, setIdcard] = useState('');
    // const [birthDate, setBirthDate] = useState(currentDate);
    const [abilityType, setAbilityType] = useState(CNF.abilityTypes[0].value);
    const [eduBackground, setEduBackground] = useState(CNF.eduBackgrounds[0].value);
    const [number, setNumber] = useState('');
    const [orgInfoULID, setOrgInfoULID] = useState('');
    const [orgStructureOrgULID, setOrgStructureOrgULID] = useState('');
    const [orgStructureJobULID, setOrgStructureJobULID] = useState('');
    const [address, setAddress] = useState('');
    const [entryDate, setEntryDate] = useState('');
    const [leaveDate, setLeaveDate] = useState('');
    const [description, setDescription] = useState('');

    const [orgStructuresLists, setOrgStructuresLists] = useState([]);

    const cancel = () => {
        setOpen(false, null);
    }

    useEffect(() => {
        // 修改初始化
        if (record) {
            setSex(record.sex || CNF.sexs[0].value);
            setIdcard(record.idcard);
            // setBirthDate(record.birth_date || currentDate);
            setAbilityType(record.ability_type || CNF.abilityTypes[0].value);
            setEduBackground(record.edu_background || CNF.eduBackgrounds[0].value);
            setNumber(record.number);
            setOrgInfoULID(record.org_info_ulid || props.orgInfoULID || '');
            setOrgStructureOrgULID(record.org_structure_org_ulid || '');
            setOrgStructureJobULID(record.org_structure_job_ulid || '');
            setAddress(record.address || '');
            setEntryDate(record.entry_date || currentDate);
            setLeaveDate(record.leave_date || currentDate);
            setDescription(record.description);
        }
    }, [record, props.orgInfoULID]);

    useEffect(() => {
        setOrgStructuresLists(props.orgStructuresLists);
    }, [props.orgStructuresLists]);

    const getOrgStructuresLists = (orgInfoULID) => {
        const params = {
            rss: 'list',
            org_info_ulid: orgInfoULID,
            status: CNF.status[0].value,
        };
        $.ajax({
            url: `${CNF.api}orgs/structures${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
            dataType: 'JSON', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        setOrgStructuresLists(data.dat);
                    } else {
                        setOrgStructuresLists([]);
                    }
                }
            }
        })
    }



    const update = () => {
        //  从身份证上获取出生年月
        var birthDate = idcard.substr(6, 4);      //  年
        birthDate += '-' + idcard.substr(10, 2);  //  月
        birthDate += '-' + idcard.substr(12, 2);  //  日

        //  执行修改
        $.ajax({
            url: `${CNF.api}users/infos/${record.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                sex: sex,
                idcard: idcard,
                birth_date: birthDate,
                ability_type: abilityType,
                edu_background: eduBackground,
                org_info_ulid: orgInfoULID,
                org_structure_org_ulid: orgStructureOrgULID,
                org_structure_job_ulid: orgStructureJobULID,
                address: address,
                entry_date: entryDate,
                leave_date: leaveDate,
                number: number,
                description: description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (err) {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    }

    const ok = () => {
        if (!sex) {
            messageApi.error('性别不可为空！');
            return;
        }
        if (!idcard) {
            message.error('身份证号不可为空！');
            return;
        }
        var rex = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/;
        if (!rex.test(idcard)) {
            message.error('身份证号格式错误！');
            return;
        }
        if (!abilityType) {
            message.error('能力类型不可为空！');
            return;
        }
        if (!eduBackground) {
            message.error('学历不可为空！');
            return;
        }

        setLoading(true);

        if (record) {
            update();
        } else {
            // 
        }
    };



    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={640}
                title={'修改员工信息：' + record?.displayname}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={11}><Text>性别</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={2}><Text>身份证号</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <Radio.Group
                                onChange={(value) => setSex(value)}
                                value={sex}
                                disabled={loading}
                            >
                                {
                                    CNF.sexs && CNF.sexs.map((item) => {
                                        return <Radio key={item.value} value={item.value}>{item.key}</Radio>
                                    })
                                }
                            </Radio.Group>
                        </Col>
                        <Col span={11} offset={2}>
                            <Input
                                value={idcard}
                                placeholder='请输入'
                                style={{ width: '100%' }}
                                onChange={(e) => setIdcard(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>学历</Text></Col>
                        <Col span={11} offset={2}><Text>能力类型</Text></Col>
                        <Col span={11}>
                            <Select
                                value={eduBackground || undefined}
                                style={{ width: '100%' }}
                                onChange={(value) => setEduBackground(value)}
                                disabled={loading}
                                options={
                                    CNF.eduBackgrounds?.map(item => ({
                                        key: item.value,
                                        value: item.value,
                                        label: item.key
                                    })) ?? []
                                }
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <Select
                                value={abilityType || undefined}
                                style={{ width: '100%' }}
                                onChange={(value) => setAbilityType(value)}
                                disabled={loading}
                                options={
                                    CNF.abilityTypes?.map(item => ({
                                        key: item.value,
                                        value: item.value,
                                        label: item.key
                                    })) ?? []
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>入职日期</Text></Col>
                        <Col span={11} offset={2}><Text>员工编号</Text></Col>
                        <Col span={11}>
                            <DatePicker
                                onChange={(_, dateString) => setEntryDate(dateString)}
                                placeholder='请选择日期'
                                value={dayjs(entryDate, 'YYYY-MM-DD')}
                                style={{ width: '100%' }}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <Input
                                placeholder='请输入'
                                value={number}
                                style={{ width: '100%' }}
                                onChange={(e) => setNumber(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>公司</Text></Col>
                        <Col span={24}>
                            <Select
                                value={orgInfoULID || undefined}
                                style={{ width: '100%' }}
                                onChange={(value) => {
                                    setOrgInfoULID(value);
                                    getOrgStructuresLists(value);
                                    setOrgStructureOrgULID('');
                                    setOrgStructureJobULID('');
                                }}
                                disabled={loading}
                                options={[
                                    ...(props.orgInfosLists.length > 1 ? [{ value: '', label: '请选择公司' }] : []),
                                    ...props.orgInfosLists.map(item => ({
                                        value: item.key,
                                        label: item.name,
                                        key: item.key,
                                    }))
                                ]}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>部门</Text></Col>
                        <Col span={11} offset={2}><Text>岗位</Text></Col>
                        <Col span={11}>
                            <Select
                                value={orgStructureOrgULID || undefined}
                                style={{ width: '100%' }}
                                placeholder='请选择部门'
                                onChange={(value, option) => {
                                    setOrgStructureOrgULID(value || '');
                                    setOrgStructureJobULID('');
                                    setSid(option?.sid || '');
                                }}
                                disabled={loading}
                                options={
                                    orgStructuresLists
                                        ?.filter(item => parseInt(item['org_function_type']) !== parseInt(CNF.orgFunctionTypes[2].value))
                                        .map(item => ({
                                            key: item.key,
                                            value: item.key,
                                            label: item.title,
                                            sid: item.sid,
                                        })) ?? []
                                }
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <Select
                                value={orgStructureJobULID || undefined}
                                style={{ width: '100%' }}
                                placeholder='请选择岗位'
                                onChange={(value) => setOrgStructureJobULID(value)}
                                disabled={loading}
                                options={
                                    orgStructuresLists
                                        ?.filter(item => {
                                            // 只保留岗位类
                                            if (parseInt(item['org_function_type']) !== parseInt(CNF.orgFunctionTypes[2].value)) {
                                                return false;
                                            }

                                            // 如果选择了部门，则只展示对应部门的岗位
                                            if (sid) {
                                                return sid === item['up_sid'];
                                            }

                                            // 否则则全部保留
                                            return true;
                                        })
                                        .map(item => ({
                                            key: item.key,
                                            value: item.key,
                                            label: item.title
                                        })) ?? []
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>住址</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                value={address}
                                style={{ width: '100%' }}
                                onChange={(e) => setAddress(e.target.value)}
                                disabled={loading}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>备注</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity